<template>
    <div class="mt-5 w-full flex align-items-center justify-content-center">

        <div class="w-full flex flex-column align-items-center p-6" style="color: var(--theme-font-color); min-width: 15rem; max-width: 35rem; width: 88vw; border: 1px solid var(--theme-color5); border-radius: 18px;">

            <div class="w-full flex-column align-items-center" :class="{ 'flex': !httpAuthorizationAutoLoginLoading, 'hidden': httpAuthorizationAutoLoginLoading}">
                <div class="w-full flex-column align-items-center" :class="{ 'flex': !authorizationSessionIsInvalid, 'hidden': authorizationSessionIsInvalid}">
                    <div class="w-full flex-column align-items-center" :class="{ 'flex': !authorizationCallback, 'hidden': authorizationCallback}">
                        <span style="color: var(--theme-font-color); font-size: var(--register-maintitle-font-size); font-weight: var(--register-maintitle-font-weight);" class="text-center">Sign In</span>
                        <div class="mt-5 flex-column align-items-center" style="gap: 0.7rem; width: 100%;" :class="{ 'flex': !httpAuthorizationLoginLoading, 'hidden': httpAuthorizationLoginLoading}">
                            <!--<span v-if="accountNotValidMessage" class="align-self-start error-message mb-2 flex align-items-center gap-1" style="color: var(--inputcomponent-invalid-color);">
                                {{ accountNotValidMessage }}
                                <div class="flex align-items-center" v-tooltip.top="{ value:`Note: Store and Help Desk accounts are separate and won't work here. To access the License Manager, please create a new account if you haven’t already.` }">
                                    <SvgInfoCircle className="pluscircle-svg" color="var(--inputcomponent-invalid-color)"/>
                                </div>
                            </span>-->
                            <span v-if="accountNotValidMessage" class="align-self-start error-message mb-2 flex flex-column align-items-left justify-content-center gap-1" style="color: var(--inputcomponent-invalid-color);">
                                {{ accountNotValidMessage }}
                                <span>
                                    <strong>Important</strong>: Your <strong>Softron Online Store</strong> or <strong>Help Desk</strong> accounts <strong>do not work</strong> here! These services are <strong>separate</strong> from the <strong>Softron License Manager</strong> platform.
                                </span>
                            </span>
                            <div class="registerlogin-section">
                                <div class="registerlogin-subsection relative">
                                    <span class="subtitle">Email<span style="color: var(--mydanger-color);">*</span></span>
                                    <InputText class="w-full register-inputtext" v-model="email" aria-describedby="admin-help" :class="{ 'p-invalid': (errorEmailMessage && isValidEmail(email)!=='success') || accountDoesntExist }" type="email" name="email" autocomplete="username"/>
                                    <span v-if="errorEmailMessage" class="error-message" style="color: var(--inputcomponent-invalid-color);">{{ errorEmailMessage }}</span>
                                    <span v-if="accountDoesntExist" class="error-message" style="color: var(--inputcomponent-invalid-color);">This account does not exist. Register instead.</span>
                                </div>
                            </div>
                            <div class="registerlogin-section gap-1">
                                <div class="registerlogin-subsection relative">
                                    <span class="subtitle">Password<span style="color: var(--mydanger-color);">*</span></span>
                                    <PasswordInputText v-model:val="password" class="register-password" uid="passwordRegister" @update-val="(val) => password=val" :isInvalid="(errorPasswordMessage && isValidPasswordLogin(password)!=='success') || wrongPassword" type="password" name="password" autocomplete="current-password"/>
                                    <span v-if="errorPasswordMessage" class="error-message mb-2" style="color: var(--inputcomponent-invalid-color);">{{ errorPasswordMessage }}</span>
                                    <span v-if="wrongPassword" class="error-message mb-2" style="color: var(--inputcomponent-invalid-color);">The password is incorrect.</span>
                                </div>
                            </div>
                            <div class="flex flex-row my-4 gap-1 align-items-center">
                                <Checkbox v-model="rememberMe" :binary="true"/>
                                <span style="font-size: var(--register-text-font-size); font-weight: var(--register-text-font-weight);">Remember Me</span>
                            </div>
                            <TurnstileWidget widgetId="authLoginTurnstileWidget" @human-verified="(token) => {turnstileToken = token; isHumanVerified = true}"/>
                            <div class="flex flex-column w-full gap-2 align-items-center">
                                <ButtonModule type="primary" severity="normal" label="Sign In" @click="clickedLogin(email, password)" :disabled="!enableLogin" class="mb-4"/>
                                <span style="font-size: var(--register-subtext-font-size); font-weight: var(--register-subtext-font-weight);">
                                    Don't have an account?
                                    <router-link unstyled :to="{ path: '/register'}" style="text-decoration: none;">
                                        <span id="clickable-text" class="cursor-pointer" style="font-size: var(--register-subtext-font-size); font-weight: var(--register-subtext-font-weight);">Register.</span>
                                    </router-link>
                                </span>
                                <span id="forgot-password-text" class="cursor-pointer" style="font-size: var(--register-subtext-font-size); font-weight: var(--register-subtext-font-weight);" @click="showForgotPasswordDialog = true">Forgot Password?</span>
                            </div>
                        </div>
                        <div v-if="httpAuthorizationLoginLoading" style="height: 40vh;" class="flex align-items-center justify-content-center">
                            <LoadingSpinner/>
                        </div>
                    </div>
                    <div v-if="authorizationCallback" class="w-full flex flex-column align-items-center justify-content-center gap-4">
                        <span style="color: var(--theme-font-color); font-size: var(--login-maintitle-font-size); font-weight: var(--login-maintitle-font-weight);" class="mx-5 px-8 text-center">
                            <span>Sign in as </span>
                            <span>{{ loggedInEmail }}</span>
                        </span>

                        <div class="flex flex-column w-full gap-2 align-items-center">
                            <ButtonModule type="primary" severity="normal" :label="(applicationName && applicationName != '') ? `Open ${applicationName}` : 'Open the Softron Application'" @click="clickedOpenSoftronApplication"/>
                            <span style="font-size: var(--login-subtext-font-size); font-weight: var(--login-subtext-font-weight);">
                                Not this user?
                                <span id="clickable-text" class="cursor-pointer" style="text-decoration: none; font-size: var(--login-subtext-font-size); font-weight: var(--login-subtext-font-weight);" @click="loginWithAnotherAccount">Login with another account.</span>
                            </span>
                        </div>
                    </div>
                </div>

                <div v-if="authorizationSessionIsInvalid" class="w-full flex flex-column align-items-center justify-content-center gap-6">
                    <span style="color: var(--theme-font-color); font-size: var(--login-maintitle-font-size); font-weight: var(--login-maintitle-font-weight);" class="mx-5 px-8 text-center">This login session is not valid anymore.</span>

                    <div class="flex flex-column w-full gap-2 align-items-center">
                        <SvgError class="mb-4" className="registerconfirm-svg" color="var(--mydanger-color)"/>
                        <span style="font-size: var(--login-subtext-font-size); font-weight: var(--login-subtext-font-weight);">
                            You can close this tab.
                        </span>
                    </div>
                </div>
            </div>

            <div v-if="httpAuthorizationAutoLoginLoading" style="height: 12vh;" class="flex align-items-center justify-content-center">
                <LoadingSpinner/>
            </div>
        </div>

        <!-- DIALOGS -->

        <!-- Forgot Password window -->
        <ForgotPasswordDialog :showDialog="showForgotPasswordDialog" :currentEmail="email" @close="showForgotPasswordDialog = false"/>
    </div>
</template>

<script setup>
// --- IMPORTS ---
import { ref, toRefs, computed, onMounted, onBeforeUnmount } from 'vue';
// PrimeVue
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
// vue
import PasswordInputText from '@/components/Modules/PasswordInputText.vue'
import ButtonModule from '@/components/Modules/ButtonModule.vue'
import ForgotPasswordDialog from '@/components/Dialogs/OtherDialogs/ForgotPasswordDialog.vue'
import LoadingSpinner from '@/components/Modules/LoadingSpinner.vue';
import SvgError from '@/components/SVGs/SvgError.vue'
import SvgInfoCircle from '@/components/SVGs/SvgInfoCircle.vue';
import TurnstileWidget from '@/components/Modules/TurnstileWidget.vue';
// Others
import InputsUtils from '@/composables/InputsUtils'
import toastService from '@/composables/toastService';
import { useRouter } from 'vue-router'
import { useStore } from 'vuex';

// API
import useApiRequest from '@/composables/HTTPS/useApiRequest';
const { fetchAuthorizationAutoLogin, fetchAuthorizationLogin } = useApiRequest()
const httpAuthorizationAutoLoginLoading = ref(false)
const httpAuthorizationAutoLoginData = ref(null)
const httpAuthorizationLoginLoading = ref(false)
const httpAuthorizationLoginData = ref(null)

const { isValidEmail, isValidPasswordLogin } = InputsUtils()

// --- PROPS ---
const props = defineProps({
    session_uid: String
})
const { session_uid } = toRefs(props)

// --- EMITS ---
const emit = defineEmits(['login'])

// --- VARIABLES ---
const rememberMeEmailStorageLabel = 'remember-me-email'
const email = ref(localStorage.getItem(rememberMeEmailStorageLabel))
const password = ref(null)

// Errors
const errorEmailMessage = ref(null)
const errorPasswordMessage = ref(null)
const accountDoesntExist = ref(false)
const wrongPassword = ref(false)
const accountNotValidMessage = ref(null)

// --- Remember me ---
const rememberMe = ref(true)

// --- Auto-Login ---
onMounted(async () => {
    makeAuthorizationAutoLogin()
})
const makeAuthorizationAutoLogin = async () => {
    // Send HTTP request
    httpAuthorizationAutoLoginLoading.value = true
    try {
        httpAuthorizationAutoLoginData.value = await fetchAuthorizationAutoLogin({ session_uid: session_uid.value })
        
        // Update succcessful login info
        loggedInEmail.value = httpAuthorizationAutoLoginData.value.email
        applicationName.value = httpAuthorizationAutoLoginData.value.application_name
        authorizationCallback.value = httpAuthorizationAutoLoginData.value.authorization_callback
    } catch (err) {
        // Automatic remember-me login failed : nothing to do ...
    } finally {
        httpAuthorizationAutoLoginLoading.value = false
    }
}

// --- Login ---
const authorizationCallback = ref(null)
const loggedInEmail = ref(null)
const applicationName = ref(null)
const enableLogin = computed(() => isHumanVerified.value && email.value && password.value)
const clickedLogin = async (myEmail, myPassword) => {
    errorEmailMessage.value = null
    errorPasswordMessage.value = null
    accountDoesntExist.value = false
    wrongPassword.value = false
    accountNotValidMessage.value = null
    var validSubmit = true

    // Check if valid Email
    const isValidEmailMessage = isValidEmail(myEmail)
    if (isValidEmailMessage !== 'success') { errorEmailMessage.value = isValidEmailMessage; validSubmit = false }
    // Check if valid Password
    const isValidPasswordMessage = isValidPasswordLogin(myPassword)
    if (isValidPasswordMessage !== 'success') { errorPasswordMessage.value = isValidPasswordMessage; validSubmit = false }

    // If the conditions are ok : go on
    if (!validSubmit) {
        password.value = null
        return
    }
    errorEmailMessage.value = null
    errorPasswordMessage.value = null

    // Remember Me
    if (!rememberMe.value) { // Remove what is stored in localStorage for the email
        localStorage.removeItem(rememberMeEmailStorageLabel)
    }

    // Send HTTP request
    httpAuthorizationLoginLoading.value = true
    try {
        httpAuthorizationLoginData.value = await fetchAuthorizationLogin({email: myEmail, password_plain: myPassword, session_uid: session_uid.value, cf_turnstile_response : turnstileToken.value })

        // Remember Me
        if (rememberMe.value) { // Store the email in localStorage
            localStorage.setItem(rememberMeEmailStorageLabel, myEmail)
        }

        // Reset of values
        email.value = null
        password.value = null
        accountDoesntExist.value = false
        wrongPassword.value = false

        // Update successful login info
        loggedInEmail.value = httpAuthorizationLoginData.value.email
        applicationName.value = httpAuthorizationLoginData.value.application_name
        authorizationCallback.value = httpAuthorizationLoginData.value.authorization_callback

        // Callback to the app
        window.location.href = authorizationCallback.value
    } catch (err) {
        window.turnstile.reset("#authLoginTurnstileWidget")
        handleAuthorizationLoginError(err)
    } finally {
        password.value = null
        httpAuthorizationLoginLoading.value = false
    }
}
// Handle an error from the server
const authorizationSessionIsInvalid = ref(false)
const handleAuthorizationLoginError = (error) => {
    try {
        if (error.response == null) { // If there is no .response key, then it means it is not an error from the server, it did not reach it
            toastService.add({ severity: 'error', summary: `Login: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
            return;
        }
        const errorStatus = error.response.status
        const errorCode = error.response.data.error_code
        const errorMessage = error.response.data.error_message
        switch (errorStatus) {
            case 400: // Missing info = MISSING_OBJ / MISSING_OBJ_ELEM (400) => toast
                if (errorCode == 'MISSING_OBJ' || errorCode == 'MISSING_OBJ_ELEM') {
                    toastService.add({ severity: 'warn', summary: "Login: Missing Information.", detail: 'It seems that the request body does not contain the necessary information.', life: 5000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Login: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 401: // INVALID_AUTHORIZATION_SESSION / ACCOUNT_NOT_VALID / CLOUDFLARE_TURNSTILE_INVALID
                if (errorCode == 'INVALID_AUTHORIZATION_SESSION') {
                    // toastService.add({ severity: 'error', summary: `Login: Invalid Authorization Session.`, detail: errorMessage, life: 5000 });
                    authorizationSessionIsInvalid.value = true
                }
                else if (errorCode == 'ACCOUNT_NOT_VALID') {
                    accountNotValidMessage.value = errorMessage
                } else if (errorCode == 'CLOUDFLARE_TURNSTILE_INVALID') {
                    toastService.add({ severity: 'error', summary: `Login: Cloudflare Verification Error.`, detail: "The Cloudflare verification is no longer valid — this can happen if too much time passes before submitting. Please redo the verification and try again.", life: 10000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Login: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 403: // Account registered but not validated (check mails) = ACCOUNT_NOT_CONFIRMED (403) => toast
                if (errorCode == 'ACCOUNT_NOT_CONFIRMED') {
                    toastService.add({ severity: 'warn', summary: "Login: Account Not Confirmed.", detail: 'The account is registered but not validated yet. Please check your emails to confirm the registration.', life: 5000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Login: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 500: // DATABASE_ERROR (500) => toast
                if (errorCode == 'INTERNAL_ERROR' || errorCode == 'DATABASE_ERROR') {
                    toastService.add({ severity: 'error', summary: "Login: Internal Error.", detail: 'Sorry, it seems that there is an internal error. Try later.', life: 5000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Login: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            default:
                toastService.add({ severity: 'error', summary: `Login: Error ${errorStatus}.`, detail: errorMessage, life: 12000 });
                break;
        }
    } catch {
        toastService.add({ severity: 'error', summary: `Login: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
    }
}
// --- Forgot Password Popup ---
const showForgotPasswordDialog = ref(false)

// --- Open Softron Application ---
const clickedOpenSoftronApplication = () => {
    window.location.href = authorizationCallback.value
}

const loginWithAnotherAccount = () => {
    authorizationCallback.value = null;
    loggedInEmail.value = null;
    window.turnstile.reset("#authLoginTurnstileWidget");
}

// --- ENTER key listener ---
onMounted(() => {
    window.addEventListener('keydown', handleKeyPressed)
})
onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyPressed)
}) 
const handleKeyPressed = (event) => {
    if (!showForgotPasswordDialog.value && event.keyCode === 13) { // ENTER
        if (enableLogin.value) { clickedLogin(email.value, password.value) }
    }
}

// --- TURNSTILE ---
const turnstileToken = ref(null)
const isHumanVerified = ref(false) // turnstile
</script>

<style scoped>
/* Label */
.subtitle {
    font-size: var(--register-subtitle-font-size);
    font-weight: var(--register-subtitle-font-weight);
    opacity: 0.7;
}
/* InputText */
:deep(.p-inputtext) {
    height: 2.5rem
}
/* Checkbox */
:deep(.p-checkbox .p-checkbox-box) {
    width: 1rem;
    height: 1rem;
    align-self: center;
}
:deep(.p-checkbox .p-checkbox-box .p-icon) {
    width: 0.6rem;
    height: 0.6rem;
}
/* Forgot password */
#forgot-password-text {
    text-decoration: none;
    color: var(--button-normal-color);
    border-bottom: 1px solid transparent;
}
#forgot-password-text:hover {
    border-bottom: 1px solid var(--button-normal-color);
}
/* Go to login */
#clickable-text {
    text-decoration: none;
    color: var(--button-normal-color);
}
#clickable-text:visited {
    color: var(--button-normal-color);
}
#clickable-text:hover {
    border-bottom: 1px solid var(--button-normal-color);
}
</style>